import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "grid gap-4 md:grid-cols-3" }
const _hoisted_3 = { class: "mb-3 grid h-10 w-10 place-items-center rounded-xl bg-brand-50 text-xl font-black text-brand-700" }
const _hoisted_4 = { class: "text-lg font-bold text-ink" }
const _hoisted_5 = { class: "mt-2 text-xs leading-5 text-slate-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Trang chủ",
      title: "Quản lý tài sản Mobifone",
      description: "Theo dõi tài sản, tình trạng bàn giao, thiết bị hết hạn và báo cáo vận hành trong một dashboard thống nhất."
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cards, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.to,
          to: item.to,
          class: "panel-pad group block transition hover:-translate-y-0.5 hover:border-brand-200"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(item.icon), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(item.desc), 1),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mt-3 inline-flex text-sm font-bold text-brand-600" }, "Mở chức năng →", -1))
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
}